module.exports = __webpack_public_path__ + "static/media/ToyotaType-Book.c7a4861b.otf";